import * as echarts from "echarts";

const componentChart = () => {
    const observeOptions = {
        root: null,
        threshold: 0.75,
    };

    const bilanzsumme = document.getElementById('bilanzsumme')
    let echartBilanzsumme
    if (bilanzsumme) {
        echartBilanzsumme = echarts.init(bilanzsumme);

        const observeEchartBilanzsumme = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    echartBilanzsumme.setOption({
                        backgroundColor: 'rgba(255,253,240,1)',
                        grid: {
                            top: 40,
                            left: 20,
                            right: 20,
                            bottom: 40,
                        },
                        tooltip: {},
                        xAxis: {
                            data: ['2022', '2023', '2024', '2025e'],
                            axisTick: false,
                            axisLine: {
                                lineStyle: {
                                    width: 0
                                }
                            },
        
                        },
                        yAxis: {
                            show: false,
                            type: 'value',        
                        },
                        series: [
                            {
                                name: 'Bilanzsumme',
                                type: 'bar',
                                barWidth: "40",
                                tooltip: {
                                    valueFormatter: function (value) {
                                        return value + ' Mio. EUR';
                                    }
                                },
                                itemStyle: {
                                    color: 'rgba(90, 203, 121, 1)'
                                },
                                label: {
                                    show: true,
                                    position: 'top',
                       
                                },
                                data: [                                    
                                    '7054.4',
                                    '6624.4',
                                    '6442.0',
                                    {
                                        value: '6570.5',
                                        itemStyle: {
                                            color: 'rgba(189,221,191,1)'
                                        },
                                        label: {
                                            show: false,
                                        },
                                        tooltip: {
                                            formatter: 'Prognose: + 1 - 2 %'
                                        },
                                    },

                                ],
                            }
                        ]
                    });
                }

                return
            });
        }, observeOptions);

        observeEchartBilanzsumme.observe(bilanzsumme);
    }

    const kundengelder = document.getElementById('kundengelder')
    let echartKundengelder
    if (kundengelder) {
        echartKundengelder = echarts.init(kundengelder);

        const observeEchartKundengelder = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    echartKundengelder.setOption({
                        backgroundColor: 'rgba(255,253,240,1)',
                        grid: {
                            top: 40,
                            left: 20,
                            right: 20,
                            bottom: 40,
                        },
                        tooltip: {},
                        xAxis: {
                            data: ['2022', '2023', '2024', '2025e'],
                            axisTick: false,
                            axisLine: {
                                lineStyle: {
                                    width: 0
                                }
                            },
                        },
                        yAxis: {
                            show: false,
                        },
                        series: [
                            {
                                name: 'Kundengelder',
                                type: 'bar',
                                barWidth: "40",
                                tooltip: {
                                    valueFormatter: function (value) {
                                        return value + ' Mio. EUR';
                                    }
                                },
                                itemStyle: {
                                    color: 'rgba(90, 203, 121, 1)'
                                },
                                label: {
                                    show: true,
                                    position: 'top',
                                },
                                data: [ 
                                    '5590.0',
                                    '4789.6',
                                    '4679.9',
                                    {
                                        value: '4773.6',
                                        itemStyle: {
                                            color: 'rgba(189,221,191,1)'
                                        },
                                        label: {
                                            show: false,
                                        },
                                        tooltip: {
                                            formatter: 'Prognose: + 1 - 2 %'
                                        },
                                    },

                                ],
                            }
                        ]
                    });
                }

                return
            });
        }, observeOptions);

        observeEchartKundengelder.observe(kundengelder);
    }

    const kreditgeschaeft = document.getElementById('kreditgeschaeft')
    let echartKreditgeschaeft
    if (kreditgeschaeft) {
        echartKreditgeschaeft = echarts.init(kreditgeschaeft);

        const observeEchartKreditgeschaeft = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    echartKreditgeschaeft.setOption({
                        backgroundColor: 'rgba(255,253,240,1)',
                        grid: {
                            top: 40,
                            left: 20,
                            right: 20,
                            bottom: 40,
                        },
                        tooltip: {},
                        xAxis: {
                            data: ['2022', '2023', '2024', '2025e'],
                            axisTick: false,
                            axisLine: {
                                lineStyle: {
                                    width: 0
                                }
                            },
                        },
                        yAxis: {
                            show: false,
                        },
                        series: [
                            {
                                name: 'Kreditgeschäft',
                                type: 'bar',
                                barWidth: "40",
                                tooltip: {
                                    valueFormatter: function (value) {
                                        return value + ' Mio. EUR';
                                    }
                                },
                                itemStyle: {
                                    color: 'rgba(90, 203, 121, 1)'
                                },
                                label: {
                                    show: true,
                                    position: 'top',
                                },
                                data: [                   
                
                                    '2832.7',
                                    '3009.6',
                                    '3176.1',
                                    {
                                        value: '3303.1',
                                        itemStyle: {
                                            color: 'rgba(189,221,191,1)'
                                        },
                                        label: {
                                            show: false,
                                        },
                                        tooltip: {
                                            formatter: 'Prognose: + 4 %'
                                        },
                                    },

                                ],
                            }
                        ]
                    });
                }

                return
            });
        }, observeOptions);

        observeEchartKreditgeschaeft.observe(kreditgeschaeft);
    }

    const kundenwertpapiervolumen = document.getElementById('kundenwertpapiervolumen')
    let echartKundenwertpapiervolumen
    if (kundenwertpapiervolumen) {
        echartKundenwertpapiervolumen = echarts.init(kundenwertpapiervolumen);

        const observeEchartKundenwertpapiervolumen = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    echartKundenwertpapiervolumen.setOption({
                        backgroundColor: 'rgba(255,253,240,1)',
                        grid: {
                            top: 40,
                            left: 20,
                            right: 20,
                            bottom: 40,
                        },
                        tooltip: {},
                        xAxis: {
                            data: ['2022', '2023', '2024', '2025e'],
                            axisTick: false,
                            axisLine: {
                                lineStyle: {
                                    width: 0
                                }
                            },
                        },
                        yAxis: {
                            show: false,
                        },
                        series: [
                            {
                                name: 'Kundenwertpapiervolumen',
                                type: 'bar',
                                barWidth: "40",
                                tooltip: {
                                    valueFormatter: function (value) {
                                        return value + ' Mio. EUR';
                                    }
                                },
                                itemStyle: {
                                    color: 'rgba(90, 203, 121, 1)'
                                },
                                label: {
                                    show: true,
                                    position: 'top',
                                },
                                data: [                     
                                    '4238.0',
                                    '5010.1',
                                    '5235.5',
                                    {
                                        value: '5444.9',
                                        itemStyle: {
                                            color: 'rgba(189,221,191,1)'
                                        },
                                        label: {
                                            show: false,
                                        },
                                        tooltip: {
                                            formatter: 'Prognose: + 4 %'
                                        },
                                    },

                                ],
                            }
                        ]
                    });
                }

                return
            });
        }, observeOptions);

        observeEchartKundenwertpapiervolumen.observe(kundenwertpapiervolumen);
    }

    window.onresize = function () {
        if (bilanzsumme) {
            echartBilanzsumme.resize();
        }
        if (kundengelder) {
            echartKundengelder.resize();
        }
        if (kreditgeschaeft) {
            echartKreditgeschaeft.resize();
        }
        if (kundenwertpapiervolumen) {
            echartKundenwertpapiervolumen.resize();
        }
    };
};

export default componentChart;
